/**
 * As notas de uma ou mais versões, como aparecem no aviso de atualização e no rodapé.
 *
 * Curta de propósito: quem lê está no meio do trabalho. Cada item é uma linha do
 * NOVIDADES.md, com a etiqueta "novo" ou "correção" quando o item tem o prefixo.
 */

import type { NovidadesDaVersao, TipoDaNovidade } from "./novidades"

const ETIQUETA: Record<TipoDaNovidade, { texto: string; fundo: string; cor: string }> = {
  novo: { texto: "novo", fundo: "var(--ok-soft)", cor: "var(--ok-on-soft)" },
  correcao: { texto: "correção", fundo: "var(--acao-soft)", cor: "var(--acao-on-soft)" },
}

export function ListaDeNovidades({ versoes, limite, titulo = true }: {
  versoes: readonly NovidadesDaVersao[]
  /** Quantos itens no total, somando as versões; o resto vira "e mais N". */
  limite?: number
  /** Mostra "v2.4.0" acima dos itens de cada versão. */
  titulo?: boolean
}) {
  let restam = limite ?? Infinity
  let escondidos = 0

  const blocos = versoes.map((v) => {
    const cabem = v.itens.slice(0, Math.max(0, restam))
    escondidos += v.itens.length - cabem.length
    restam -= cabem.length
    return { ...v, itens: cabem }
  }).filter((v) => v.itens.length > 0)

  if (blocos.length === 0) return null

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6, fontFamily: "var(--ff)" }}>
      {blocos.map((v) => (
        <div key={v.versao}>
          {titulo && (
            <div style={{ fontSize: 10.5, fontWeight: 650, color: "var(--txt3)", fontFamily: "var(--fm)", marginBottom: 2 }}>
              v{v.versao}
            </div>
          )}
          <ul style={{ margin: 0, padding: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: 3 }}>
            {v.itens.map((item, i) => (
              <li key={i} style={{ display: "flex", gap: 6, alignItems: "baseline", fontSize: 12, lineHeight: 1.4 }}>
                {item.tipo ? (
                  <span style={{
                    flex: "0 0 auto", padding: "0 5px", borderRadius: 4, fontSize: 10, fontWeight: 600,
                    background: ETIQUETA[item.tipo].fundo, color: ETIQUETA[item.tipo].cor,
                  }}>
                    {ETIQUETA[item.tipo].texto}
                  </span>
                ) : (
                  <span aria-hidden="true" style={{ flex: "0 0 auto", color: "var(--txt3)" }}>•</span>
                )}
                <span style={{ color: "var(--txt)", whiteSpace: "normal" }}>{item.texto}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
      {escondidos > 0 && (
        <div style={{ fontSize: 11, color: "var(--txt3)" }}>
          e mais {escondidos} {escondidos === 1 ? "mudança" : "mudanças"}
        </div>
      )}
    </div>
  )
}
